"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[87109],{

/***/ 72294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "aX": function() { return /* binding */ BorderedButton; },
  "W2": function() { return /* binding */ Container; },
  "uG": function() { return /* binding */ ContentGrid; },
  "iz": function() { return /* binding */ Divider; },
  "Pz": function() { return /* binding */ HeaderWrapper; },
  "Bx": function() { return /* binding */ LeftSection; },
  "AX": function() { return /* binding */ PortfolioContainer; },
  "lV": function() { return /* binding */ RightSection; },
  "Od": function() { return /* binding */ Skeleton; },
  "iA": function() { return /* binding */ Table; },
  "pj": function() { return /* binding */ TableCell; },
  "SC": function() { return /* binding */ TableRow; },
  "Zh": function() { return /* binding */ ThickDivider; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/features/fast-order/FastOrderSkeleton/utils.ts
var convertToPixel = function(value) {
    if (value === undefined) return value;
    return typeof value === "number" ? "".concat(value, "px") : value;
};

;// CONCATENATED MODULE: ./src/features/fast-order/FastOrderSkeleton/colors.ts
var lightColors = {
    text: {
        primary: "#333333",
        secondary: "#858585",
        tertiary: "#B5B5B5",
        specialSecondary: "#6B6B6B",
        white: "#FFFFFF",
        green: "#00AB6B",
        red: "#EE4A49",
        orange: "#F5931B",
        periwinkle: "#8277F8",
        purple: "#8250A3",
        violet: "#9343C8",
        liberty: "#6159B8"
    },
    artboard: {
        surfaceDefault: "#FFFFFF",
        surfaceVariant: "#F7F7F7",
        surfaceEmphasis: "#F7F7F7",
        surfaceHighlight: "#F2F2F2",
        dividerThin: "#F1F1F1",
        dividerThick: "#F7F7F7",
        border: "#EDEDED",
        borderGreen: "#0BA16B",
        borderRed: "#EE4A49",
        borderOrange: "#F5931B",
        borderPeriwinkle: "#8277F8"
    },
    modals: {
        surfaceDefault: "#FFFFFF",
        surfaceEmphasis: "#F7F7F7",
        surfaceHighlight: "#F2F2F2",
        dividerThin: "#F1F1F1",
        dividerThick: "#F7F7F7",
        border: "#EDEDED",
        borderGreen: "#0BA16B",
        borderRed: "#D74342",
        borderOrange: "#E4830C",
        borderPeriwinkle: "#796FEC"
    },
    icon: {
        default: "#969696",
        lowerEmphasis: "rgba(150, 150, 150, 0.6)",
        white: "#FFFFFF",
        green: "#0BA16B",
        red: "#D74342",
        orange: "#E4830C",
        periwinkle: "#796FEC"
    },
    semantic: {
        inactive: "#CBCBCB",
        active: "#00AB6B",
        error: "#EE4A49",
        warning: "#F5931B",
        informative: "#8277F8"
    },
    peach: {
        low: "#FBF0F0",
        medium: "#F7E1E0",
        default: "#D96A65"
    },
    red: {
        low: "#FDEDED",
        medium: "#FBDFDF",
        default: "#EE4A49"
    },
    orange: {
        low: "#322311",
        medium: "#422C11",
        default: "#E4830C"
    },
    yellow: {
        low: "#352B14",
        medium: "#4C3C15",
        default: "#FCBC1D"
    },
    brown: {
        low: "#2C241B",
        medium: "#3A2D20",
        default: "#966B40"
    },
    olive: {
        low: "#222617",
        medium: "#30361D",
        default: "#89A23F"
    },
    green: {
        low: "#EBF8F3",
        medium: "#CCEEE1",
        default: "#0BA16B"
    },
    turqoise: {
        low: "#093029",
        medium: "#10564A",
        default: "#35CBB1"
    },
    teal: {
        low: "#112925",
        medium: "#0F4138",
        default: "#09AE91"
    },
    navy: {
        low: "#1A212D",
        medium: "#1C2537",
        default: "#34518D"
    },
    cobalt: {
        low: "#14222B",
        medium: "#162D3D",
        default: "#2073AC"
    },
    blue: {
        low: "#19262E",
        medium: "#203846",
        default: "#439ACB"
    },
    periwinkle: {
        low: "#1E1D2C",
        medium: "#2D2A4B",
        default: "#796FEC"
    },
    violet: {
        low: "#1F1527",
        medium: "#281634",
        default: "#8228BD"
    },
    purple: {
        low: "#221B27",
        medium: "#32233C",
        default: "#7E4B9F"
    },
    pink: {
        low: "#281A25",
        medium: "#43253A",
        default: "#E65BBF"
    },
    magenta: {
        low: "#231421",
        medium: "#30152C",
        default: "#861D75"
    }
};

;// CONCATENATED MODULE: ./src/features/fast-order/FastOrderSkeleton/styled.ts


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background-color: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background-color: transparent;\n    border: 1px solid #f7f7f7;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  height: ",
        ";\n  width: ",
        ";\n  border-radius: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  background-color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n\n  margin-bottom: 8px;\n\n  background-color: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  flex: 1;\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: 1fr;\n  grid-column-gap: 8px;\n  max-width: 100%;\n  position: relative;\n\n  @media only screen and (min-width: 728px) {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  @media only screen and (min-width: 1048px) {\n    grid-template-columns: 680px 1fr;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  background-color: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  display: none;\n  background-color: ",
        ";\n\n  @media only screen and (min-width: 728px) {\n    display: flex;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  row-gap: 10px;\n\n  border-radius: 4px;\n  border: 1px solid ",
        ";\n  padding: 12px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 1px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 8px;\n  background-color: #f6f6f6;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n\n  display: flex;\n  align-items: stretch;\n  gap: 1px;\n  width: 100%;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20%;\n  padding: 5px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  padding: 1px;\n  width: 100%;\n  text-align: center;\n  background-color: ",
        ";\n\n  border-radius: 4px;\n\n  & > ",
        ":first-of-type {\n    > ",
        ":first-of-type {\n      border-top-left-radius: 4px;\n    }\n\n    > ",
        ":last-of-type {\n      border-top-right-radius: 4px;\n    }\n  }\n\n  & > ",
        ":last-of-type {\n    > ",
        ":first-of-type {\n      border-bottom-left-radius: 4px;\n    }\n\n    > ",
        ":last-of-type {\n      border-bottom-right-radius: 4px;\n    }\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 80px;\n  height: 28px;\n  border: 1px solid #f7f7f7;\n  border-radius: 14px;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}



var variantStyles = function(param) {
    var background = param.background;
    return {
        default: (0,styled_components_browser_esm/* css */.iv)(_templateObject(), background || "#f7f7f7"),
        outline: (0,styled_components_browser_esm/* css */.iv)(_templateObject1())
    };
};
var Skeleton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5de9bc8-0"
})(_templateObject2(), function(_param) {
    var _variant = _param.variant, variant = _variant === void 0 ? "default" : _variant, props = (0,_object_without_properties/* default */.Z)(_param, [
        "variant"
    ]);
    return variantStyles(props)[variant];
}, function(param) {
    var height = param.height;
    return convertToPixel(height);
}, function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width;
    return convertToPixel(width);
}, function(param) {
    var rounded = param.rounded, width = param.width, height = param.height;
    if (typeof width === "number") {
        return rounded ? convertToPixel(width / 2) : "6px";
    }
    if (typeof height === "number") {
        return rounded ? convertToPixel(height / 2) : "6px";
    }
    return rounded ? "50%" : "6px";
});
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5de9bc8-1"
})(_templateObject3(), lightColors.modals.border);
var HeaderWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5de9bc8-2"
})(_templateObject4(), lightColors.modals.surfaceDefault);
var ContentGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5de9bc8-3"
})(_templateObject5());
var LeftSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5de9bc8-4"
})(_templateObject6(), lightColors.modals.surfaceDefault);
var RightSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5de9bc8-5"
})(_templateObject7(), lightColors.modals.surfaceDefault);
var PortfolioContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5de9bc8-6"
})(_templateObject8(), lightColors.modals.surfaceEmphasis);
var Divider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5de9bc8-7"
})(_templateObject9(), lightColors.modals.surfaceEmphasis);
var ThickDivider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5de9bc8-8"
})(_templateObject10());
var TableRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5de9bc8-9"
})(_templateObject11());
var TableCell = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5de9bc8-10"
})(_templateObject12(), lightColors.modals.surfaceDefault);
var Table = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5de9bc8-11"
})(_templateObject13(), lightColors.modals.surfaceEmphasis, TableRow, TableCell, TableCell, TableRow, TableCell, TableCell);
var BorderedButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5de9bc8-12"
})(_templateObject14());


/***/ }),

/***/ 55524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* binding */ Flex; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/features/fast-order/Flex/utils.ts
var convertToPixel = function(value) {
    if (value === undefined) return value;
    return typeof value === "number" ? "".concat(value, "px") : value;
};
var generateSpaceProps = function(props) {
    var m = props.m, mt = props.mt, mr = props.mr, mb = props.mb, ml = props.ml, mx = props.mx, my = props.my, p = props.p, pt = props.pt, pr = props.pr, pb = props.pb, pl = props.pl, px = props.px, py = props.py;
    var margin = m;
    var marginTop = mt || my;
    var marginRight = mr || mx;
    var marginBottom = mb || my;
    var marginLeft = ml || mx;
    var padding = p;
    var paddingTop = pt || py;
    var paddingRight = pr || px;
    var paddingBottom = pb || py;
    var paddingLeft = pl || px;
    return {
        margin: margin && convertToPixel(margin),
        marginTop: marginTop && convertToPixel(marginTop),
        marginRight: marginRight && convertToPixel(marginRight),
        marginBottom: marginBottom && convertToPixel(marginBottom),
        marginLeft: marginLeft && convertToPixel(marginLeft),
        padding: padding && convertToPixel(padding),
        paddingTop: paddingTop && convertToPixel(paddingTop),
        paddingRight: paddingRight && convertToPixel(paddingRight),
        paddingBottom: paddingBottom && convertToPixel(paddingBottom),
        paddingLeft: paddingLeft && convertToPixel(paddingLeft)
    };
};
var generateLayoutProps = function(props) {
    var width = props.width, w = props.w, height = props.height, h = props.h, minWidth = props.minWidth, maxWidth = props.maxWidth, minHeight = props.minHeight, maxHeight = props.maxHeight, position = props.position, cursor = props.cursor;
    return {
        width: width || w,
        height: height || h,
        minWidth: minWidth,
        maxWidth: maxWidth,
        minHeight: minHeight,
        maxHeight: maxHeight,
        position: position,
        cursor: cursor
    };
};
var generateBorderProps = function(props) {
    var border = props.border, borderTop = props.borderTop, bt = props.bt, borderRight = props.borderRight, br = props.br, borderBottom = props.borderBottom, bb = props.bb, borderLeft = props.borderLeft, bl = props.bl, borderColor = props.borderColor, borderRadius = props.borderRadius, radius = props.radius;
    return {
        border: border,
        borderTop: borderTop || bt,
        borderRight: borderRight || br,
        borderBottom: borderBottom || bb,
        borderLeft: borderLeft || bl,
        borderColor: borderColor,
        borderRadius: borderRadius || radius
    };
};

;// CONCATENATED MODULE: ./src/features/fast-order/Flex/index.ts



var Flex = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f781b0f2-0"
})(function(props) {
    return (0,_object_spread/* default */.Z)({
        display: "flex",
        flex: props.flex,
        alignItems: props.align,
        justifyContent: props.justify,
        flexDirection: props.direction,
        flexWrap: props.wrap,
        gap: props.gap && convertToPixel(props.gap)
    }, generateSpaceProps(props), generateLayoutProps(props), generateBorderProps(props));
});


/***/ }),

/***/ 5562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);



var initialState = {
    symbol: ""
};
var useFastOrderForm = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialState), {
        setSymbol: function(symbol) {
            set({
                symbol: symbol
            });
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (useFastOrderForm);


/***/ }),

/***/ 52781:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ OrderbookSymbolsKeyEnum; }
/* harmony export */ });
var OrderbookSymbolsKeyEnum;
(function(OrderbookSymbolsKeyEnum) {
    OrderbookSymbolsKeyEnum["SIDE_WIDGET_ORDERBOOK_SUMMARY"] = "sideWidgetOrderbookSummary";
    OrderbookSymbolsKeyEnum["COMPANY_STREAM_ORDERBOOK"] = "companyStreamOrderbook";
    OrderbookSymbolsKeyEnum["ORDERBOOK"] = "orderbook";
    OrderbookSymbolsKeyEnum["SECURITIES_TRANSACTION"] = "securitiesTransaction";
    OrderbookSymbolsKeyEnum["FAST_ORDER"] = "fastOrder";
})(OrderbookSymbolsKeyEnum || (OrderbookSymbolsKeyEnum = {}));


/***/ }),

/***/ 10272:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "jN": function() { return /* binding */ natsOrderbookFormatter; }
/* harmony export */ });
/* unused harmony exports oldOrderbookFormatter, isNatsOrderbookResponse */
/* harmony import */ var utils_webSocket__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92953);

var parseSocketString = utils_webSocket__WEBPACK_IMPORTED_MODULE_0__/* ["default"].parseSocketString */ .Z.parseSocketString;
var natsOrderbookFormatter = function(rawOrderbook) {
    return {
        stockCode: rawOrderbook.stockCode,
        bid: parseSocketString(rawOrderbook.body).O["BID-RG"],
        offer: parseSocketString(rawOrderbook.body).O["OFFER-RG"]
    };
};
var oldOrderbookFormatter = function(rawOldOrderbook) {
    return {
        stockCode: rawOldOrderbook.sym,
        bid: rawOldOrderbook["BID-RG"],
        offer: rawOldOrderbook["OFFER-RG"]
    };
};
/**
 * Defined Type Guards.
 * @link https://www.typescriptlang.org/docs/handbook/2/narrowing.html#using-type-predicates
 */ var isNatsOrderbookResponse = function(rawOrderbook) {
    return rawOrderbook.datetime !== undefined;
}; // Raw Nats
 // {
 //   "stockCode": "GOTO",
 //   "body": "#O|GOTO|BID|118;0;223613500|117;0;99554900|116;0;77776600|115;0;141316000|114;0;53095000|113;0;116110800|1678949070",
 //   "sequenceNumber": "3418843",
 //   "orderBookId": "4311",
 //   "datetime": "2023-03-16T13:44:30.7964+07:00"
 // }
 // Raw Old
 // {
 //     "sym": "AALI",
 //     "BID-RG": {
 //         "price1": 7875,
 //         "que_num1": 0,
 //         "volume1": 2600,
 //         "price2": 7850,
 //         "que_num2": 0,
 //         "volume2": 101800,
 //         "price3": 7825,
 //         "que_num3": 0,
 //         "volume3": 57200,
 //         "price4": 7800,
 //         "que_num4": 0,
 //         "volume4": 236800,
 //         "price5": 7775,
 //         "que_num5": 0,
 //         "volume5": 12700,
 //         "price6": 7750,
 //         "que_num6": 0,
 //         "volume6": 20900,
 //         "price7": 7725,
 //         "que_num7": 0,
 //         "volume7": 10100,
 //         "price8": 7700,
 //         "que_num8": 0,
 //         "volume8": 50700,
 //         "price9": 7675,
 //         "que_num9": 0,
 //         "volume9": 21900,
 //         "price10": 7650,
 //         "que_num10": 0,
 //         "volume10": 148900
 //     },
 //     "OFFER-RG": {
 //       "price1": 8325,
 //       "que_num1": 0,
 //       "volume1": 2198200,
 //       "price2": 8350,
 //       "que_num2": 0,
 //       "volume2": 949900,
 //       "price3": 8375,
 //       "que_num3": 0,
 //       "volume3": 848400,
 //       "price4": 8400,
 //       "que_num4": 0,
 //       "volume4": 1026900,
 //       "price5": 8425,
 //       "que_num5": 0,
 //       "volume5": 864500,
 //       "price6": 8450,
 //       "que_num6": 0,
 //       "volume6": 840200,
 //       "price7": 8475,
 //       "que_num7": 0,
 //       "volume7": 1601900,
 //       "price8": 8500,
 //       "que_num8": 0,
 //       "volume8": 1519500,
 //       "price9": 8525,
 //       "que_num9": 0,
 //       "volume9": 310400,
 //       "price10": 8550,
 //       "que_num10": 0,
 //       "volume10": 1057200
 //     }
 // }


/***/ }),

/***/ 49816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ useRawOrderbookReceiver; },
/* harmony export */   "q": function() { return /* binding */ useOrderbookReceiver; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _useDatafeedMessageEffect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49696);
/* harmony import */ var _useOrderbook_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10272);





var useOrderbookReceiver = function(symbols, key, onMessage) {
    var stringSymbols = symbols.join();
    var handleReceiveMessage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(message) {
            var orderbook, formattedOrderbook;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        orderbook = (message || {}).orderbook;
                        if (orderbook && stringSymbols.split(",").includes(orderbook.stockCode)) {
                            formattedOrderbook = (0,_useOrderbook_utils__WEBPACK_IMPORTED_MODULE_3__/* .natsOrderbookFormatter */ .jN)(orderbook);
                            onMessage(formattedOrderbook, orderbook);
                        }
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(message) {
            return _ref.apply(this, arguments);
        };
    }(), [
        stringSymbols,
        onMessage
    ]);
    // Nats Socket Receiver
    (0,_useDatafeedMessageEffect__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("orderbook", "".concat(key, ":").concat(symbols.join()), handleReceiveMessage);
};
var useRawOrderbookReceiver = function(symbols, key, onMessage) {
    var stringSymbols = symbols.join();
    var handleReceiveMessage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(message) {
            var orderbook;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        orderbook = (message || {}).orderbook;
                        if (orderbook && stringSymbols.split(",").includes(orderbook.stockCode)) {
                            onMessage(orderbook);
                        }
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(message) {
            return _ref.apply(this, arguments);
        };
    }(), [
        stringSymbols,
        onMessage
    ]);
    // Nats Socket Receiver
    (0,_useDatafeedMessageEffect__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("orderbook", "".concat(key, ":").concat(symbols.join()), handleReceiveMessage);
};


/***/ }),

/***/ 64579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ useOrderbookSender; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _orderbook_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23782);


var useOrderbookSender = function(key, symbols) {
    var setOrderbookSymbols = (0,_orderbook_store__WEBPACK_IMPORTED_MODULE_1__/* .useOrderbookStore */ .a)().setOrderbookSymbols;
    var stringSymbols = symbols.join();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var symbolList = stringSymbols ? stringSymbols.split(",") : [];
        setOrderbookSymbols(key, symbolList);
        return function() {
            return setOrderbookSymbols(key, []);
        };
    }, [
        stringSymbols,
        key,
        setOrderbookSymbols
    ]);
};


/***/ }),

/***/ 11562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J6": function() { return /* binding */ useBestBidOfferSender; },
/* harmony export */   "tC": function() { return /* binding */ useBestBidReceiver; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _useDatafeedAuthEffect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39834);
/* harmony import */ var _useDatafeedMessageEffect__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49696);
/* harmony import */ var _useDatafeedSocket__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92924);






var CHANNEL = "bestBidOffer";
var useBestBidOfferSender = function(symbols) {
    var setChannel = (0,_useDatafeedSocket__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().setChannel;
    var stringSymbols = symbols.filter(function(v, i, a) {
        return a.indexOf(v) === i;
    }).join();
    (0,_useDatafeedAuthEffect__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var bestBidOffer = stringSymbols ? stringSymbols.split(",") : [];
        setChannel({
            bestBidOffer: bestBidOffer
        });
    }, [
        stringSymbols
    ]);
};
var useBestBidReceiver = function(symbols, key, onMessage) {
    var stringSymbols = symbols.filter(function(v, i, a) {
        return a.indexOf(v) === i;
    }).join();
    var KEY = "".concat(key, ":").concat(stringSymbols);
    var onReceiveMessage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(message) {
            var bestBidOffer;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        bestBidOffer = (message || {}).bestBidOffer;
                        if (bestBidOffer && stringSymbols.split(",").includes(bestBidOffer.stockCode)) {
                            onMessage(bestBidOffer);
                        }
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(message) {
            return _ref.apply(this, arguments);
        };
    }(), [
        stringSymbols,
        onMessage
    ]);
    (0,_useDatafeedMessageEffect__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(CHANNEL, KEY, onReceiveMessage);
};
var useBestBidOffer = function(symbols, key, onMessage) {
    useBestBidOfferSender(symbols);
    useBestBidReceiver(symbols, key, onMessage);
};
/* harmony default export */ __webpack_exports__["ZP"] = (useBestBidOffer);


/***/ }),

/***/ 39834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87637);


var useDatafeedAuthEffect = function(callback, deps) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(___WEBPACK_IMPORTED_MODULE_1__/* .DatafeedContext */ .y), socket = ref.socket, isAuthorized = ref.isAuthorized;
    var handleCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(callback, deps);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (isAuthorized) handleCallback(socket);
    }, [
        isAuthorized,
        handleCallback
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useDatafeedAuthEffect);


/***/ }),

/***/ 92924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87637);


var useDatafeedSocket = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(___WEBPACK_IMPORTED_MODULE_1__/* .DatafeedContext */ .y);
};
/* harmony default export */ __webpack_exports__["Z"] = (useDatafeedSocket);


/***/ }),

/***/ 28398:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jj": function() { return /* binding */ useOrderbookIEPIEV; },
/* harmony export */   "Yc": function() { return /* binding */ useOrderbookIEPIEVReceiver; },
/* harmony export */   "_1": function() { return /* binding */ useOrderbookIEPIEVSender; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _useDatafeedAuthEffect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39834);
/* harmony import */ var _useDatafeedMessageEffect__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49696);
/* harmony import */ var _useDatafeedSocket__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92924);






var useOrderbookIEPIEVSender = function(symbols) {
    var setChannel = (0,_useDatafeedSocket__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().setChannel;
    var stringSymbols = symbols.filter(function(v, i, a) {
        return a.indexOf(v) === i;
    }).join();
    (0,_useDatafeedAuthEffect__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        setChannel({
            iepiev: stringSymbols ? stringSymbols.split(",") : []
        });
    }, [
        stringSymbols
    ]);
};
var useOrderbookIEPIEVReceiver = function(symbols, key, onMessage) {
    var stringSymbols = symbols.filter(function(v, i, a) {
        return a.indexOf(v) === i;
    }).join();
    var handleReceiveMessage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(message) {
            var iepiev;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        iepiev = (message || {}).iepiev;
                        if (iepiev && stringSymbols.split(",").includes(iepiev.stockCode)) {
                            onMessage(iepiev);
                        }
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(message) {
            return _ref.apply(this, arguments);
        };
    }(), [
        stringSymbols,
        onMessage
    ]);
    (0,_useDatafeedMessageEffect__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("iepiev", "".concat(key, ":").concat(stringSymbols), handleReceiveMessage);
};
var useOrderbookIEPIEV = function(symbols, key, onMessage) {
    useOrderbookIEPIEVSender(symbols);
    useOrderbookIEPIEVReceiver(symbols, key, onMessage);
};


/***/ }),

/***/ 52870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var typings_transactionForm__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93134);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14671);
/* harmony import */ var zustand_middleware__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38597);





var initialState = {
    formType: typings_transactionForm__WEBPACK_IMPORTED_MODULE_0__/* .TransactionFormType.Classic */ .b.Classic
};
var useTransactionFormStore = (0,zustand__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_2__/* .persist */ .tJ)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, initialState), {
        setFormType: function(formType) {
            set({
                formType: formType
            });
        }
    });
}, {
    name: "@fast-trade/shell-transaction-form"
}));
/* harmony default export */ __webpack_exports__["Z"] = (useTransactionFormStore);


/***/ }),

/***/ 93134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ TransactionFormType; }
/* harmony export */ });
var TransactionFormType;
(function(TransactionFormType) {
    TransactionFormType["Classic"] = "Classic";
    TransactionFormType["FastOrder"] = "FastOrder";
})(TransactionFormType || (TransactionFormType = {}));


/***/ })

}]);